import MineLayout from '../../layouts/MineLayout.vue'

export default {
  sort: 2,
  path: '/mine',
  name: 'mine',
  component: MineLayout,
  children: [
    {
      path: '',
      redirect: 'entrust'
    },
    {
      path: 'entrust',
      name: 'mine-entrust',
      component: () => import('@/views/Mine/entrust.vue')
    },
    {
      path: 'accountManagement',
      name: 'mine-recommend',
      component: () => import('@/views/User/accountManagement/index')
    },
    {
      path: 'member',
      name: 'min-member',
      component: () => import('@/views/User/consumption-records')
    },
    {
      path: 'points-mall',
      name: 'mine-points-mall',
      component: () => import('@/views/Mine/points-mall/index.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/mine.js